import { createColumn, createDropdownColumn } from "../components/Table/Table";

export const driveVersionColumns: State.Column[] = [
  createColumn(
    "Year",
    (driveVersion: Api.DriveVersion) => driveVersion.year,
    "driveVersion.year",
    true
  ),
  createColumn(
    "Week",
    (driveVersion: Api.DriveVersion) => driveVersion.week,
    "driveVersion.week",
    true
  ),
  createColumn(
    "Description",
    (driveVersion: Api.DriveVersion) => driveVersion.description,
    "driveVersion.description",
    true
  ),
  createDropdownColumn(
    "Domain",
    (driveVersion: Api.DriveVersion) => driveVersion.domainName,
    "driveVersion.domainName",
    true
  )
];
